import React, {ReactNode} from 'react'
import {Section} from './ARStyledComponents'
import {StyledLink} from '../../../../../styledComponents/adminPage/Links'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {Box} from '@mui/material'
import {OpenInNew} from '@mui/icons-material'
import {LeftRowFlexContainer} from '../../../../../styledComponents/FlexComponents'

export type StatusType = 'blank' | 'otherReservation' | 'outsideHours'

export interface OvernightFacilityReserveAvailability {
    id: number
    name: string
    status?: StatusType
}

interface Props {
    facilities: OvernightFacilityReserveAvailability[]
    onClickName?: (facilityId: number) => void
    onClickStatus?: (facilityId: number) => void
}

const ARReservationStatusViewOvernight: React.FC<Props> = props => {
    const {facilities, onClickName, onClickStatus} = props

    if (facilities.length === 0) {
        return null
    }

    return <>
        <Box mt={'15px'}>
            <Section>宿泊施設</Section>
        </Box>
        <Box mt={'8px'} width={'100%'}>
            <OvernightTable>
                <tbody>
                {
                    facilities.map(facility => {
                        return <OvernightTableRow key={facility.id}>
                            <OvernightTableFacilityName>
                                <FacilityNameLinkButton onClick={() => {
                                    if (!onClickName) {
                                        return
                                    }
                                    onClickName(facility.id)
                                }}>
                                    {facility.name}
                                </FacilityNameLinkButton>
                            </OvernightTableFacilityName>
                            <OvernightTableData dataLoading={!facility.status}>
                                {
                                    facility.status ?
                                        <OvernightTableAvailableButton onClick={() => {
                                            if (!onClickStatus) {
                                                return
                                            }
                                            onClickStatus(facility.id)
                                        }}
                                        >
                                            <LeftRowFlexContainer>
                                                <OpenInNew fontSize={'small'}/>
                                                <Box ml={'5px'}>
                                                    {convertToStatusMessage(facility.status)}
                                                </Box>
                                            </LeftRowFlexContainer>
                                        </OvernightTableAvailableButton>
                                        : convertToStatusMessage(facility.status)
                                }
                            </OvernightTableData>
                        </OvernightTableRow>
                    })
                }
                </tbody>
            </OvernightTable>
        </Box>
    </>
}
ARReservationStatusViewOvernight.displayName = 'ARReservationStatusViewOvernight'
export default ARReservationStatusViewOvernight

const convertToStatusMessage = (status?: StatusType): ReactNode => {
    if (!status) {
        return 'データ取得中…'
    }

    switch (status) {
        case 'otherReservation':
            return '予約あり(予約不可)'
        case 'blank':
            return '空きあり'
        case 'outsideHours':
            return '時間外'
        default:
            throw new Error('unknown status ' + status)
    }
}

const OvernightTable = styled.table`
  background-color: ${Colors.Surface};
  border-bottom: solid 1px ${Colors.AccentLight};
  border-spacing: 0;
  width: 100%;
`

const OvernightTableRow = styled.tr`
  height: 50px;
`

const OvernightTableData = styled.td<{ dataLoading?: boolean }>`
  box-sizing: border-box;
  border-top: solid 1px ${Colors.AccentLight};
  padding: 0 0 0 15px;
  width: 100%;
  color: #707070;
  font-size: 12px;
  background-color:  ${props => props.dataLoading ? '#f8f8f8' : 'white'};
`

const OvernightTableFacilityName = styled.td`
  box-sizing: border-box;
  padding: 0 4px;
  border-top: solid 1px ${Colors.AccentLight};
  border-right: solid 1px ${Colors.AccentLight};
  width: 245px;
  min-width: 245px;
  max-width: 245px;
`

const FacilityNameLinkButton = styled(StyledLink)`
  font-size: 16px;
  text-align: left;
  height: 49px;
  width: 100%;
  white-space: normal;
  overflow: hidden;
`

const OvernightTableAvailableButton = styled(StyledLink)`
  font-size: 16px;
  height: 49px;
  width: 100%;
  white-space: normal;
  overflow: hidden;
`
